module.exports = __webpack_public_path__ + "img/star-thin-fill.4ffba240.svg";